import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Box,
  Grid,
  Button,
  Paper,
  Typography,
} from "@material-ui/core";
import { backend } from "../../../../api";
import { Skeleton } from "@material-ui/lab";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: "5px",
    marginTop: "30px",
    padding: "10px",
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  },
  tabHeading: {
    fontSize: "32px",
    fontWeight: 550,
    margin: "0",
  },
}));

function Favourites(props) {
  const classes = useStyles();
  const { user } = props;
  const [favourites, setFavourites] = useState();
  useEffect(() => {
    handleFetchFavourites();
  }, []);

  const handleFetchFavourites = () => {
    backend
      .get(`/favourite?customer=${user.user._id}`)
      .then((res) => {
        setFavourites(res.data.data[0]);
      })
      .catch((err) => {
        toast.error(err.response ? err.response.data.message : err.message);
      });
  };

  return (
    <div className={classes.root}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <h2 className={classes.tabHeading}>My Favourites</h2>
      </Box>
      {favourites && Boolean(favourites.article.length) ? (
        <Grid container spacing={2}>
          {favourites.article.map((article, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Paper elevation={2} style={{ padding: 10 }}>
                <h3 style={{ margin: 0 }}>{article.article_title}</h3>
                <p style={{ margin: 0 }}>
                  <b>Total Pages: </b>
                  {article.number_of_pages}
                </p>
                <p style={{ margin: 0 }}>
                  <b>Per Page Price: </b>
                  {article.per_page_price} $
                </p>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mt={3}
                >
                  <Button className={classes.articleBtn}>
                    Remove from Favourites
                  </Button>
                  <Button color="primary" variant="contained">
                    Buy Now
                  </Button>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box>
          <Typography
            variant="h2"
            color="error"
            style={{ margin: "30px auto" }}
          >
            No Articles in Your Favourites
          </Typography>
        </Box>
      )}
    </div>
  );
}

export default Favourites;
